import { ContactCategoryEnum } from '@/features/contact/enums/contactCategory';

export interface ContactSupportRequest {
  submissionReason: ContactCategoryEnum;
  message: string;
  email: string;
  userId: string;
  browser: string;
  device: string;
  plan: string;
  attachments?: string[];
}

interface ContactSupportResponse {
  success: boolean;
  message: string;
}

export class ContactService {
  static async submitSupportRequest(
    payload: ContactSupportRequest
  ): Promise<ContactSupportResponse> {
    const baseUrl = process.env.NEXT_PUBLIC_API_URL;

    if (!baseUrl) {
      throw new Error('Contact support service is unavailable');
    }

    const response = await fetch(`${baseUrl}/users/contact-support`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = (await response
      .json()
      .catch(() => null)) as ContactSupportResponse | null;

    if (!response.ok || !data?.success) {
      throw new Error(data?.message || 'Failed to process support request');
    }

    return data;
  }
}
